import {
  NotificationOpenedResultData,
  NotificationOpenedResult,
} from "@app/core/notifications/domain/notification-open-result";
import { OpenedEvent } from "onesignal-cordova-plugin/dist/models/NotificationOpened";

export class OneSignalPushNotificationMapper {
  static deserialize(param: OpenedEvent): NotificationOpenedResult {
    return {
      data: OneSignalPushNotificationMapper.deserializeAdditionalData(
        param.notification.additionalData as AdditionalData
      ),
    };
  }

  private static deserializeAdditionalData(
    data: AdditionalData
  ): NotificationOpenedResultData {
    return {
      id: data.id_notification,
      url: data.url,
    };
  }
}

interface AdditionalData {
  id_notification: number;
  url?: string;
}
